import type { ReactiveComponent } from "vue-utils"
import { defineComponent } from "vue-utils"
import BasicPage from "./BasicPage"

const NotFoundPage: ReactiveComponent = () => () => (
	<BasicPage title="Not Found">The page you requested could not be found.</BasicPage>
)

export default defineComponent(NotFoundPage)
